<template>
  <div id="wrap-doc-info" v-if="!!raw_document.key">

    <v-divider></v-divider>

    <!-- Abstract -->
    <section id="container-info">
      <div id="contents-info">

        <!-- Type -->
        <div id="contents-info-type">
          <div id="contents-info-type-left">
            <!-- doctype -->
            <div id="type">
              <div :style="setColor(document.doc_type)" class="doctype-dot"></div>
              <div>{{ doc_type_model[document.doc_type]['name'] }}</div>
            </div>
          </div>
          <div id="contents-info-type-right" v-if="route_name!='watching-project'">
            <!-- Star -->
            <div id="star" v-if="!!Object.keys(document).includes('star')">
              <v-btn icon @click="setStar(document.key, document.star==0?1:0)">
                <v-icon v-if="!!document.star" color="#ffbf51">mdi-star</v-icon>
                <v-icon v-else color="#bac2cc">mdi-star-outline</v-icon>
              </v-btn>
            </div>
            <!-- Tag -->
            <div id="tag" v-if="!!Object.keys(document).includes('tags')">
              <v-menu offset-x>
                <template v-slot:activator="{ on: { click } }">
                  <div v-on:click.stop.prevent="click">
                    <v-btn icon>
                      <v-icon v-if="!!document.tags" :color="document.tags">mdi-tag</v-icon>
                      <v-icon v-else color="#bac2cc">mdi-tag-outline</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-list dense>
                  <v-list-item @click="setTags(document.key, '')">
                    <div><v-icon small>mdi-tag-outline</v-icon></div>
                  </v-list-item>
                    <v-list-item v-for="(item, index) in project_tags" :key="index"
                      @click="setTags(document.key, item)">
                      <div><v-icon small :style="{'color': item}">mdi-tag</v-icon></div>
                    </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div id="contents-info-content">

          <!-- title -->
          <div id="title">
            <div>{{ document.title }}</div>
          </div>

          <!-- TODO: wholes -->
          <!-- <div v-if="!!wholes.length">
            <span>in</span>
            <a v-for="(doc, i) in wholes" :key=i>
              <span>{{ doc.title }}</span>
            </a>
          </div> -->

          <!-- authors(year): editors, translators -->
          <div id="authors">
            <span v-if="!!document.authors_iso690">
              <span>{{ document.authors_iso690 }}</span>
              <span v-if="document.authors.length>1">(authors)</span>
              <span v-else>({{ $t('doc_info.author') }})</span>
            </span>
            <span v-if="!!raw_document.editors_iso690">
              <span> - {{ raw_document.editors_iso690 }}</span>
              <span v-if="raw_document.editors.length>1">(editors)</span>
              <span v-else>({{ $t('doc_info.editor') }})</span>
            </span>
            <span v-if="!!raw_document.translators_iso690">
              <span> - {{ raw_document.translators_iso690 }}</span>
              <span v-if="raw_document.translators.length>1">(translators)</span>
              <span v-else>({{ $t('doc_info.translator') }})</span>
            </span>
            <span v-if="!!document.authors_iso690 || 
              !!raw_document.editors_iso690 || !!raw_document.translators_iso690"> - </span>
            <span>{{ document.date }}</span>
          </div>

          <!-- pub: pub_title, numeration, pagination -->
          <div id="pub"
            v-if="!!document.publication||!!document.number||!!document.pages">
            <span v-if="!!document.publication">
              {{ document.publication }}
            </span>
            <span v-if="!!document.number">
              {{ document.number }}
            </span>
            <span v-if="!!document.pages">
              <span v-if="!!document.publication||!!document.number"> - </span>
              {{ document.pages }}
            </span>
          </div>

          <!-- DOI -->
          <div class="url" v-if="!!document.DOI_URL">
            <div><v-icon small>mdi-alpha-d-circle-outline</v-icon></div>
            <a :href="document.DOI_URL" target="_blank" 
              @click="gaClick('documentInfo_btn_url')"
              class="cyan_blue--text">
              {{ document.DOI }}
            </a>
          </div>

          <div class="url" v-if="!!document.pub_DOI_URL">
            <div><v-icon small>mdi-alpha-d-circle-outline</v-icon></div>
            <a :href="document.pub_DOI_URL" target="_blank" 
              @click="gaClick('documentInfo_btn_url')"
              class="cyan_blue--text">
              {{ document.pub_DOI }}
            </a>
          </div>

          <!-- URL -->
          <div class="url" v-if="!!document.URL">
            <div><v-icon small>mdi-link</v-icon></div>
            <a :href="document.URL" target="_blank" 
              @click="gaClick('documentInfo_btn_url')"
              class="cyan_blue--text">
              {{ document.URL }}
            </a>
          </div>

          <div class="url" v-if="!!document.pub_URL">
            <div><v-icon small>mdi-link</v-icon></div>
            <a :href="document.pub_URL" target="_blank" 
              @click="gaClick('documentInfo_btn_url')"
              class="cyan_blue--text">
              {{ document.pub_URL }}
            </a>
          </div>

          <!-- TODO: My URL -->
          <!-- <div class="url">
            <div><v-icon small>mdi-cloud</v-icon></div>
          </div> -->

        </div>
      </div>
    </section>

    <!-- Detail -->
    <section id="container-detail">
      <v-divider></v-divider>

      <div class="section-header">
        <div class="section-header-title">상세 정보</div>
        <div class="section-header-tools">
          <div class="underlined-element" @click="reportIssue">틀린 정보 신고하기</div>
          <v-btn v-if="show_detail" class="header-button"
            icon @click="opened_detail=!opened_detail">
            <v-icon v-if="!opened_detail">mdi-chevron-down</v-icon>
            <v-icon v-else>mdi-chevron-up</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="contents-detail-wrap" v-if="show_detail&&opened_detail">
        <v-divider></v-divider>
        <div class="contents-detail">

          <!-- abstract -->
          <div id="abstract" v-if="!!document.description">
            <div v-if="document.description.length>max_description&&!full_description">
              <div>{{ description_abs }}</div>
              <div class="more" @click="full_description=true">
                <span class="underlined-element">상세정보 열기</span>
                <v-icon small>mdi-chevron-down</v-icon>
              </div>
            </div>
            <div v-else-if="document.description.length>max_description">
              <div>{{ document.description }}</div>
              <div class="more" @click="full_description=false">
                <span class="underlined-element">상세정보 닫기</span>
                <v-icon small>mdi-chevron-up</v-icon>
              </div>
            </div>
            <div v-else>
              <div>{{ document.description }}</div>
            </div>
          </div>

          <!-- keywords -->
          <div id="keywords" class="detail-wrap" v-if="!!document.keywords">
            <div class="detail-title">{{ $t('input_form.keywords') }}</div>
            <div class="detail-text">
              <span v-for="n in document.keywords.length-1" :key=n>
                {{ document.keywords[n-1] }};</span>
              <span>{{ document.keywords[document.keywords.length-1] }}</span>
            </div>
          </div>

          <!-- Language -->
          <div class="detail-wrap" v-if="!!raw_document.lang">
            <div class="detail-title">{{ $t('input_form.language') }}</div>
            <div class="detail-text">
              {{ language_model[raw_document.lang].name }}
            </div>
          </div>

          <!-- pub_date -->
          <div class="detail-wrap" v-if="!!document.pub_date">
            <div class="detail-title">{{ $t('input_form.publishing_date') }}</div>
            <div class="detail-text">
              {{ document.pub_date }}
            </div>
          </div>

          <!-- con_dates -->
          <div class="detail-wrap" v-if="!!document.con_dates">
            <div class="detail-title">{{ $t('input_form.conference_dates') }}</div>
            <div class="detail-text">
              {{ document.con_dates }}
            </div>
          </div>

          <!-- publisher -->
          <div class="detail-wrap" v-if="!!document.publisher">
            <div class="detail-title">{{ $t('input_form.publisher') }}</div>
            <div class="detail-text">
              {{ document.publisher.name }}
            </div>
          </div>

          <!-- Edition -->
          <div class="detail-wrap" v-if="!!document.edition">
            <div class="detail-title">{{ $t('input_form.edition') }}</div>
            <div class="detail-text">
              {{ document.edition }}
            </div>
          </div>

          <!-- ISBN -->
          <div class="detail-wrap" v-if="!!raw_document.ISBN">
            <div class="detail-title">{{ $t('input_form.isbn') }}</div>
            <div class="detail-text">
              {{ raw_document.ISBN }}
            </div>
          </div>

          <!-- ISSN -->
          <div class="detail-wrap" v-if="!!raw_document.ISSN">
            <div class="detail-title">{{ $t('input_form.issn') }}</div>
            <div class="detail-text">
              {{ raw_document.ISSN }}
            </div>
          </div>

          <!-- OCLC -->
          <div class="detail-wrap" v-if="!!raw_document.OCLC">
            <div class="detail-title">{{ $t('input_form.oclc') }}</div>
            <div class="detail-text">
              {{ raw_document.OCLC }}
            </div>
          </div>

          <!-- paper_ebook -->
          <div class="detail-wrap" v-if="!!raw_document.paper_ebook">
            <div class="detail-title">{{ $t('input_form.paper_ebook') }}</div>
            <div class="detail-text">
              {{ raw_document.paper_ebook }}
            </div>
          </div>

          <!-- department -->
          <div class="detail-wrap" v-if="!!raw_document.department">
            <div class="detail-title">{{ $t('input_form.department') }}</div>
            <div class="detail-text">
              {{ raw_document.department }}
            </div>
          </div>

          <!-- law_category -->
          <div class="detail-wrap" v-if="!!raw_document.law_category">
            <div class="detail-title">{{ $t('input_form.law_category') }}</div>
            <div class="detail-text">
              {{ raw_document.law_category }}
            </div>
          </div>

          <!-- paper_online -->
          <div class="detail-wrap" v-if="!!raw_document.paper_online">
            <div class="detail-title">{{ $t('input_form.online_paper') }}</div>
            <div class="detail-text">
              {{ raw_document.paper_online }}
            </div>
          </div>

          <!-- place -->
          <div class="detail-wrap" v-if="!!raw_document.place">
            <div class="detail-title">{{ $t('input_form.place') }}</div>
            <div class="detail-text">
              {{ raw_document.place }}
            </div>
          </div>

          <!-- dvd_online -->
          <div class="detail-wrap" v-if="!!raw_document.dvd_online">
            <div class="detail-title">{{ $t('input_form.dvd_online') }}</div>
            <div class="detail-text">
              {{ raw_document.dvd_online }}
            </div>
          </div>

          <!-- doc_note -->
          <div class="detail-wrap" v-if="!!raw_document.doc_note">
            <div class="detail-title">{{ $t('input_form.doc_note') }}</div>
            <div class="detail-text">
              {{ raw_document.doc_note }}
            </div>
          </div>

          <!-- paper_digital -->
          <div class="detail-wrap" v-if="!!raw_document.paper_digital">
            <div class="detail-title">{{ $t('input_form.digital_paper') }}</div>
            <div class="detail-text">
              {{ raw_document.paper_digital }}
            </div>
          </div>

          <!-- other_idf -->
          <div class="detail-wrap" v-if="!!raw_document.other_idf">
            <div class="detail-title">{{ $t('input_form.other_idf') }}</div>
            <div class="detail-text">
              {{ raw_document.other_idf }}
            </div>
          </div>

          <!-- film_note -->
          <div class="detail-wrap" v-if="!!raw_document.film_note">
            <div class="detail-title">{{ $t('input_form.film_note') }}</div>
            <div class="detail-text">
              {{ raw_document.film_note }}
            </div>
          </div>

          <!-- etc_note -->
          <div class="detail-wrap" v-if="!!raw_document.etc_note">
            <div class="detail-title">{{ $t('input_form.note') }}</div>
            <div class="detail-text">
              {{ raw_document.etc_note }}
            </div>
          </div>

        </div>
      </div>

    </section>

    <!-- Review -->
    <section id="container-review" v-if="route_name!='watching-project'">
      <v-divider></v-divider>
      <app-document-note :title="document.title"
        :dockey="raw_document.key"/>
    </section>

    <!-- References -->
    <section id="container-references">
      <v-divider></v-divider>

      <div class="section-header">
        <v-tabs v-model="tab_item" color="#536bff">
          <v-tab>{{ $t('doc_info.references') }} [{{ referred_docs.length }}]</v-tab>
          <v-tab v-if="!!referring_docs.length">
            {{ $t('doc_info.referred_by') }} [{{ referring_docs.length }}]
          </v-tab>
        </v-tabs>
      </div>

      <div id="contents-references-wrap">
        <v-divider></v-divider>
        <div class="contents-detail">

          <!-- TODO: setHoveredKey -->
          <div class="refs-out-cards" v-if="tab_item==0">

            <div class="contents-detail-header">
              <div class="contents-detail-header-left">
                <!-- Sort -->
                <div v-if="!!referred_docs.length">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        <v-btn icon color="#c1c3c9">
                          <v-icon>mdi-sort-descending</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list dense>
                      <v-list-item @click="referred_sort_by=referred_sort_by==1?0:1">
                        <v-list-item-icon small>
                          <v-icon v-if="referred_sort_by==0" color="#536bff">mdi-arrow-up</v-icon>
                          <v-icon v-if="referred_sort_by==1" color="#536bff">mdi-arrow-down</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          {{ $t('sorting.title') }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="referred_sort_by=referred_sort_by==3?2:3">
                        <v-list-item-icon small>
                          <v-icon v-if="referred_sort_by==2" color="#536bff">mdi-arrow-up</v-icon>
                          <v-icon v-if="referred_sort_by==3" color="#536bff">mdi-arrow-down</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          {{ $t('sorting.date') }}
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="referred_sort_by=referred_sort_by==5?4:5">
                        <v-list-item-icon small>
                          <v-icon v-if="referred_sort_by==4" color="#536bff">mdi-arrow-up</v-icon>
                          <v-icon v-if="referred_sort_by==5" color="#536bff">mdi-arrow-down</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          {{ $t('sorting.author') }}
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>

                <div v-if="!!referred_docs.length">
                  <v-menu offset-y id="title-drawer-menu">
                    <template v-slot:activator="{ on: { click } }">
                      <div v-on:click.stop.prevent="click">
                        <v-btn icon color="#c1c3c9">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-list dense>
                      <v-list-item @click="openEditMode('referred')">
                        <div>리스트 편집하기</div>
                      </v-list-item>
                      <v-list-item>
                        <div>추출하기 (준비중)</div>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>

                <div v-if="edit_mode">
                  <v-btn @click="edit_mode=false"
                    rounded depressed small dark color="#485158">
                    편집 완료
                  </v-btn>
                </div>
              </div>

              <div class="contents-detail-header-right" v-if="!raw_document.ref_status">
                <v-btn rounded depressed dark small color="#536bff"
                  @click.stop="showAddReferences()">
                  <v-icon small>mdi-plus</v-icon>
                  {{ $t('doc_info.add_references') }}
                </v-btn>
              </div>
            </div>
            <div class="ref-card" v-for="(ref, index) in referred_docs" :key="index">
              <div class="ref-card-content">
                <div class="card-header">
                  <div class="header-title">
                    <!-- TODO: edit mode -->
                    <div class="header-title-index" v-if="!edit_mode">
                      [{{ index + 1 }}]
                    </div>
                    <div v-else>
                      <v-btn x-small icon
                        @click.stop="remove_key=ref.key;remove_dialog=true">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </div>
                    <div @click="selectDocument(ref.key)" class="link-element">
                      <v-clamp :max-lines="1">{{ ref.title }}</v-clamp>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="card-meta">
                    <span v-if="ref.authors_iso690!='N.R., null'">
                      {{ ref.authors_iso690 }}
                    </span>
                    <span v-if="!!ref.date">
                      ({{ ref.date }})
                    </span>
                  </div>
                  <div class="card-detail">
                    <span v-if="!!ref.publication">{{ ref.publication }}</span>
                    <span v-if="!!ref.number">{{ ref.number }}</span>
                    <span v-if="!!ref.publisher">
                      <span v-if="!!ref.publication||!!ref.number"> - </span>
                      <span>{{ ref.publisher }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="refs-in-cards" v-if="tab_item==1">
            <div class="ref-card" v-for="(ref, index) in referring_docs" :key="index">
              <div class="ref-card-content">
                <div class="card-header">
                  <div class="header-title">
                    <!-- TODO: edit mode -->
                    <div class="header-title-index" v-if="!edit_mode">
                      [{{ index + 1 }}]
                    </div>
                    <div @click="selectDocument(ref.key)" class="link-element">
                      <v-clamp :max-lines="1">{{ ref.title }}</v-clamp>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="card-meta">
                    <span v-if="ref.authors_iso690!='N.R., null'">
                      {{ ref.authors_iso690 }}
                    </span>
                    <span v-if="!!ref.date">
                      ({{ ref.date }})
                    </span>
                  </div>
                  <div class="card-detail">
                    <span v-if="!!ref.publication">{{ ref.publication }}</span>
                    <span v-if="!!ref.number">{{ ref.number }}</span>
                    <span v-if="!!ref.publisher">
                      <span v-if="!!ref.publication||!!ref.number"> - </span>
                      <span>{{ ref.publisher }}</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>

    <!-- Remove Dialog -->
    <template>
      <v-dialog v-model="remove_dialog" width="400px">
        <v-card>
          <v-card-title>
            이 참고문헌을 삭제하시겠습니까?
          </v-card-title>
          <v-card-text>
            이 작업은 되돌릴 수 없습니다.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="remove_dialog=false">
              {{ $t('actions.close') }}
            </v-btn>
            <v-btn small depressed color="primary"
              @click="removeReferences()">
              {{ $t('doc_list.remove') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Report Modal -->
    <modal-report-issue
      :dialog.sync="report_issue_visible">
    </modal-report-issue>
  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters, mapMutations } from 'vuex'
import { doc_types, languages, project_tags } from '../../../custom/model'
import { returnDocDetail, sortDocuments, changeDOIFormat } from '../../../custom/function'
import AppDocumentNote from '../../spa/document/DocumentNote.vue'

export default {

  components: {
    VClamp,
    AppDocumentNote,
  },

  data() {
    return {
      doc_type_model: doc_types,
      language_model: languages,
      project_tags,

      document: {},
      report_issue_visible: false,

      referred_docs: [],
      referring_docs: [],
      // originals: [],
      // translations: [],
      // pre_versions: [],
      // post_versions: [],
      // wholes: [],
      // parts: [],

      referred_sort_by: 4,
      referring_sort_by: 4,
      edit_mode: false,

      opened_detail: false,
      opened_references: false,

      full_description: false,
      max_description: 300,

      tab_item: 0,

      remove_key: null,
      remove_dialog: false,
    }
  },

  computed: {
    ...mapGetters({
      raw_document: 'document/document',
      raw_referred_docs: 'document/referred_docs',
      raw_referring_docs: 'document/referring_docs',
      // raw_originals: 'document/originals',
      // raw_translations: 'document/translations',
      // raw_pre_versions: 'document/pre_versions',
      // raw_post_versions: 'document/post_versions',
      // raw_wholes: 'document/wholes',
      // raw_parts: 'document/parts',
      proj_docs: 'project/documents',
    }),

    route_name() {
      return this.$route.name
    },

    doc_key() {
      return this.$route.query.doc
    },

    proj_id() {
      return this.$route.params.id
    },

    description_abs() {
      let text = this.document.description
      if (!!text && text.length > this.max_description) {
        return text.slice(0, this.max_description-1) + '...'
      } else {
        return text
      }
    },

    show_detail() {
      return !!this.document.description
    },

  },

  watch: {
    raw_document: {
      handler(val) {
        if (!!Object.keys(val).length) {
          let new_doc = JSON.parse(JSON.stringify(val))
          this.document = this.returnDocDetail(new_doc, new_doc.doc_type)
          if (!!this.document.DOI) {
            var doi_obj = this.changeDOIFormat(this.document.DOI)
            this.document.DOI = doi_obj['doi']
            this.document.DOI_URL = doi_obj['doi_url']
          }
          if (!!this.document.pub_DOI) {
            var doi_obj = this.changeDOIFormat(this.document.pub_DOI)
            this.document.pub_DOI = doi_obj['doi']
            this.document.pub_DOI_URL = doi_obj['doi_url']
          }
          if (this.route_name=='project'&&this.proj_docs.map(v=>v.key).includes(this.doc_key)) {
            let raw_doc = this.proj_docs.filter(v=>v.key==this.doc_key)[0]
            this.document.star = raw_doc.star
            this.document.tags = raw_doc.tags
          } else if (this.route_name=='document-clip'&&this.proj_docs.map(v=>v.key).includes(this.doc_key)) {
            let raw_doc = this.proj_docs.filter(v=>v.key==this.doc_key)[0]
            this.document.tags = raw_doc.tags
            delete this.document.star
          } else {
            delete this.document.star
            delete this.document.tags
          }
          this.full_description = false
          this.edit_mode = false
        }
      },
      deep: true,
      immediate: true,
    },

    raw_referred_docs: {
      handler(val) {
        this.referred_docs = this.changeRefsForm(val, this.referred_sort_by)
      },
      deep: true,
      immediate: true,
    },

    raw_referring_docs: {
      handler(val) {
        this.referring_docs = this.changeRefsForm(val, this.referring_sort_by)
      },
      deep: true,
      immediate: true,
    },

    // raw_translations: {
    //   handler(val) {
    //     this.translations = this.changeRefsForm(val, this.rels_sort_by)
    //   },
    //   deep: true,
    //   immediate: true,
    // },

    // raw_pre_versions: {
    //   handler(val) {
    //     this.pre_versions = this.changeRefsForm(val, this.rels_sort_by)
    //   },
    //   deep: true,
    //   immediate: true,
    // },

    // raw_post_versions: {
    //   handler(val) {
    //     this.post_versions = this.changeRefsForm(val, this.rels_sort_by)
    //   },
    //   deep: true,
    //   immediate: true,
    // },

    // raw_wholes: {
    //   handler(val) {
    //     this.wholes = this.changeRefsForm(val, this.rels_sort_by)
    //   },
    //   deep: true,
    //   immediate: true,
    // },

    // raw_parts: {
    //   handler(val) {
    //     this.parts = this.changeRefsForm(val, this.rels_sort_by)
    //   },
    //   deep: true,
    //   immediate: true,
    // },

    referred_sort_by(val) {
      this.referred_docs = this.sortDocuments(this.referred_docs, val)
    },

    referring_sort_by(val) {
      this.referring_docs = this.sortDocuments(this.referring_docs, val)
    },

    // rels_sort_by(val) {
    //   this.pre_versions = this.sortDocuments(this.pre_versions, val)
    //   this.post_versions = this.sortDocuments(this.post_versions, val)
    //   this.wholes = this.sortDocuments(this.wholes, val)
    //   this.parts = this.sortDocuments(this.parts, val)
    // },

    edit_mode: {
      handler(val) {
        this.remove_key = null
      },
    },
  },

  methods: {
    returnDocDetail,
    sortDocuments,
    changeDOIFormat,

    ...mapMutations({
      showAddReferencesModal: 'modal/showAddDocuments',
    }),

    showAddReferences() {
      this.showAddReferencesModal()
      this.gaClick('documentInfo_btn_addReferences')
    },

    changeRefsForm(docs, sort_by) {
      let vm = this
      let new_docs = []
      if (!!docs.length) {
        docs.forEach(doc => {
          new_docs.push(vm.returnDocDetail(doc, doc.doc_type))
        })
        new_docs = this.sortDocuments(new_docs, sort_by)
      }
      return new_docs
    },

    setColor(doc_type) {
      let color = this.doc_type_model[doc_type].color
      return 'background-color:'+ color
    },

    async setStar(key, star) {
      this.document.star = star
      this.$store.commit('project/setStar', { key, star })
      // TODO: error handling
      await this.$store.dispatch('project/setStar', {
        proj_id: this.proj_id,
        doc_key: key,
        star: star
      })
    },

    async setTags(key, tags) {
      this.document.tags = tags
      this.$store.commit('project/setTags', { key, tags })
      // TODO: error handling
      await this.$store.dispatch('project/setStar', {
        proj_id: this.proj_id,
        doc_key: key,
        tags: tags
      })
    },

    selectDocument(doc_key) {
      let to = { name: this.route_name, query: { doc: doc_key } }
      this.$router.push(to)
    },

    openEditMode() {
      this.edit_mode = true
    },

    async removeReferences() {
      let vm = this
      try {
        await this.$store.dispatch('input/removeReferences', {
          doc_origin: this.doc_key,
          documents: [this.remove_key],
          proj_id: this.proj_id,
        })
      } finally {
        this.remove_dialog = false
        this.edit_mode = false
      }
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    },

    reportIssue() {
      this.report_issue_visible = true
      this.$analytics.logEvent('click', { name: 'projectDrawerDoc_btn_reportIssue' })
    },
  },

}
</script>

<style scoped>

  #container-info {
    background-color: #fafafb;
  }

  .section-header {
    padding: 0 30px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .section-header-title {
    font-size: 14px;
    font-weight: 600;
  }

  .section-header-tools {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-button {
    margin-left: 8px;
  }

  /* Info */

  #contents-info {
    padding: 12px 30px 30px;
  }

  #contents-info-type {
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  #contents-info-type-left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #type {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .doctype-dot {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }

  #contents-info-type-right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  #title {
    margin: 8px 0 16px 0;
    font-weight: 700;
    font-size: 20px;
  }

  #pub {
    margin: 8px 0;
    color: #615550;
  }

  .url {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 4px 0;
  }

  .url .v-icon {
    margin-right: 8px;
  }

  /* Detail */

  .contents-detail {
    padding: 20px 30px;
  }

  .contents-detail-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .contents-detail-header-left, .contents-detail-header-right {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .underlined-element {
    text-decoration: underline;
    cursor: pointer;
  }

  .more {
    cursor: pointer;
    margin: 8px 0;
  }

  .detail-wrap {
    display: grid;
    grid-template-columns: 80px auto;
    padding-top: 8px;
  }

  .detail-title {
    font-weight: bold;
  }

  .detail-text {
  
  }

  /* ref-card */

  .ref-card-content {
    padding-bottom: 15px;
  }

  .header-title {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header-title-index {
    padding-right: 4px;
  }

  .card-meta {
    margin: 6px 0 0 15px;
    color: #858d97;
  }

  .card-detail {
    margin: 4px 0 0 15px;
    color: rgb(97, 85, 80);
    font-style: italic;
  }

</style>


// WEBPACK FOOTER //
// src/components/shared_components/part/DocumentInfo.vue